<template>
	<GBRightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<GBModalVScrollable class="print-schedule"
			title="印刷"
			header_height="115"
			bottom_height="0"
			v-on:close="onClose"
		>
			<template v-slot:header>
				<v-layout row>
					<v-flex class="mx-2">
						<v-btn flat block large v-if="canPrintSchedule" color="white" v-on:click="onClickPrintSchedule">実行</v-btn>
						<v-btn flat block large v-else color="white" class="disabled" disabled>
							<v-progress-circular
								indeterminate
								color="white"
							></v-progress-circular>
						</v-btn>
					</v-flex>
				</v-layout>
			</template>
			<template>
				<v-layout row wrap mt-2 mx-2 pr-2>
					<v-flex xs3 class="label">
						印刷期間
					</v-flex>
					<v-flex xs4 class="label">
						<v-menu
							ref="beginCalendar"
							v-model="beginCalendar"
							:close-on-content-click="false"
							:nudge-right="40"
							lazy
							transition="scale-transition"
							full-width
						>
						<template v-slot:activator="{ on }">
						  <v-text-field
							v-model="outputBegin"
							label="開始日"
							v-on="on"
							readonly
							:rules="[rules.required]"
						  ></v-text-field>
						</template>
						<v-date-picker 
							v-model="outputBegin"
							no-title
							@input="beginCalendar = false"
							:min="beginPastPeriod"
							:max="beginFuturePeriod"
							locale="jp-ja"
							:day-format="date => new Date(date).getDate()"
						></v-date-picker>
						</v-menu>
					</v-flex>
					<v-flex xs1 class="label">
						～
					</v-flex>
					<v-flex xs4 class="label">
						<v-menu
							ref="endCalendar"
							v-model="endCalendar"
							:close-on-content-click="false"
							:nudge-right="40"
							lazy
							transition="scale-transition"
							full-width
							
						>
						<template v-slot:activator="{ on }">
						  <v-text-field
							v-model="outputEnd"
							label="終了日"
							v-on="on"
							readonly
							:rules="[rules.required]"
						  ></v-text-field>
						</template>
						<v-date-picker
							v-model="outputEnd" 
							no-title 
							@input="endCalendar = false" 
							:min="endPastPeriod" 
							:max="endFuturePeriod"
							locale="jp-ja"
							:day-format="date => new Date(date).getDate()"
						></v-date-picker>
						</v-menu>
					</v-flex>
					<div v-if="error" class="red--text text-center flex xs12 mt-3">{{ error }}</div>
				</v-layout>
			</template>
		</GBModalVScrollable>
	</GBRightPane>
</template>
<script>
import GBRightPane from './GBRightPane';
import GBModalVScrollable from './GBModalVScrollable';
import axios from 'axios';
import Notification from '../classes/Notification';
import _ from 'lodash';
import { INTERVAL,FETCH_PERIOD_RANGE } from '../data/Const';
import DataSetManager from '../classes/DataSetManager';

const strftime = require('strftime');

export default {
	name: 'GBRightPanePrintSchedule',
	props: [
		"value",
	],
	components: {
		GBRightPane,
		GBModalVScrollable,
	},
	data: function() {
		return {
			isPush:false,
			today: new Date(),
			begin: null,
			end: null,
			beginCalendar: false,
			endCalendar: false,
			beginPastPeriod: "", 
			beginFuturePeriod: "",
			endPastPeriod: "",
			endFuturePeriod: "",
			error: '',
			rules: {
				required: value => !!value || '入力してください',
			},
			throttled:'',
		};
	},
	methods: {
		getPastTermYM: function (year){
			var dt = new Date();
			dt.setFullYear(dt.getFullYear() - year);

			return strftime('%Y-%m-%d',dt);
		},
		getFutureTermYM: function (year){
			var dt = new Date();
			dt.setFullYear(dt.getFullYear() + year);

			return strftime('%Y-%m-%d',dt);
		},
		formatDate: function (date) {
			const [year, month, day] = date.split('-')
			return `${year}${month}${day}`
		},
		logout: function() {
			this.resetPeriod();
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
		onClose: function() {
			this.error = '';
			this.$emit('close');
			this.PrintTimeOut();
			this.resetPeriod();
		},
		resetPeriod: function() {
			this.beginPastPeriod = "";
			this.beginFuturePeriod = "";
			this.endPastPeriod = "";
			this.endFuturePeriod = "";
		},
		PrintTimeOut: function() {
			if(this.$store.getters.isPrintSchedule){
				this.$store.dispatch('endPrintSchedule');
			}
		},
		requestPrintSchedule: _.throttle( async function() {
			this.error = '';
			
			let access_token = await DataSetManager.confirmAccessToken(this.$store);
			if(!access_token){
				this.$store.dispatch('addNotification', Notification.error('もう一度ログインしてください'));
				this.logout();
				return;
			}
			this.$store.dispatch('startPrintSchedule');
			this.resetPeriod();
			axios
				.get('/api/v1/printschedule', {
					params: {
						'contractor_id': access_token.iss,
						'begin': this.formatDate(this.outputBegin),
						'end': this.formatDate(this.outputEnd),
						'basedate': strftime('%Y%m%d', this.$store.getters.baseDate),
						'enddate': strftime('%Y%m%d', this.$store.getters.endDate),
						'date': strftime('%Y/%m/%d %H:%M:%S', new Date()),
						'socketio_id': this.$store.getters.socketioID,
						'mode': this.$store.getters.calendarTick,
						'listtype':this.$store.getters.displayListType,
						'schedulefilter':this.$store.getters.scheduleFilterAsHash,
					},
					headers: {
						Authorization: `Bearer ${access_token.token}`,
					},
				})
				.catch((e) => {
					let notification = null;
					this.PrintTimeOut();
					switch(e.response.status) {
						case 400: notification = Notification.error('入力情報を確認してください', 'notificationPrintSchedule');	break;
						default : notification = Notification.error('通信に失敗しました', 'notificationLogin');	break;
					}
					
					if(notification)
						this.$store.dispatch('addNotification', notification);
				});
		}, INTERVAL.PRINT_SCHEDULE),
		onClickPrintSchedule:function() {
			if (this.formatDate(this.outputBegin) > this.formatDate(this.outputEnd)){
				this.error = '日付を確認してください';
				return false;
			}
			var begin = new Date(this.outputBegin);
			var end = new Date(this.outputEnd);
			var diffTime = end.getTime() - begin.getTime();
			if ( Math.floor(diffTime / (1000 * 60 * 60 * 24 * 365 * 3)) >= FETCH_PERIOD_RANGE.YEAR){
				this.error = '期間は3年以内で設定してください。';
				return false;
			}
			this.requestPrintSchedule();
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		canPrintSchedule: function() {
			return (!this.$store.getters.isPrintSchedule);
		},
		outputBegin: {
			get: function() {
				if (this.begin) {
					return this.begin;
				} else {
					return strftime('%Y-%m-%d', this.today);
				}
			},
			set: function(begin) {
				this.begin = begin;
			}
		},
		outputEnd: {
			get: function() {
				if (this.end) {
					return this.end;
				} else {
					return strftime('%Y-%m-%d', this.today);
				}
			},
			set: function(end) {
				this.end = end;
			}
		},
	},
	watch: {
		value: function() {
			this.today = new Date();
		},
		begin: function (){
			if (this.formatDate(this.outputBegin) > this.formatDate(this.outputEnd)){
				this.outputEnd = this.outputBegin; 
			}
			this.endPastPeriod = this.outputBegin;
			var dt = new Date(this.outputBegin);
			dt.setFullYear(dt.getFullYear() + FETCH_PERIOD_RANGE.YEAR);
			this.endFuturePeriod = strftime('%Y-%m-%d',dt);
		},
		end: function (){
			if (this.formatDate(this.outputBegin) > this.formatDate(this.outputEnd)){
				this.outputBegin = this.outputEnd;
			}
			this.beginFuturePeriod = this.outputEnd;
			var dt = new Date(this.outputEnd);
			dt.setFullYear(dt.getFullYear() + FETCH_PERIOD_RANGE.YEAR);
			this.beginEndPeriod = strftime('%Y-%m-%d',dt);
		}
	},
}
</script>
<style>
	.print-progress-circular{
		position: absolute;
		z-index:200;
		top: 12px;
		left: 10px;
	}
	.print-schedule .label {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 16px;
	}
	.disabled {
		pointer-events: none;
	}
</style>
